var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 100,
    viewBox: "0 0 99 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 49.6777L21.8343 70.3555H96.5677V29H21.8343L7 49.6777ZM95.0649 30.5635V68.7904H22.5887L8.87551 49.6762L22.5887 30.562L95.0649 30.5635Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4871 54.2121C21.8916 54.2121 23.8452 52.1779 23.8452 49.6778C23.8452 47.1777 21.8901 45.1436 19.4871 45.1436C17.0841 45.1436 15.1289 47.1777 15.1289 49.6778C15.1289 52.1779 17.0826 54.2121 19.4871 54.2121ZM19.4871 46.7071C21.062 46.7071 22.3424 48.0408 22.3424 49.6778C22.3424 51.3133 21.0605 52.6485 19.4871 52.6485C17.9136 52.6485 16.6317 51.3133 16.6317 49.6778C16.6317 48.0408 17.9121 46.7071 19.4871 46.7071Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0781 45.5386H79.9627M38.0781 54.5935H79.9627",
    stroke: "black",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLabel);
export default __webpack_public_path__ + "static/media/white-label.374e38a0fcf70cd23baccabe0d4ee0a0.svg";
export { ForwardRef as ReactComponent };